
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/parlors-list/[code]",
      function () {
        return require("private-next-pages/parlors-list/[code]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/parlors-list/[code]"])
      });
    }
  